export default __webpack_public_path__ + "static/media/Layout 3.1f42bc91.svg";